import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=5d752980&scoped=true"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=5d752980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d752980",
  null
  
)

export default component.exports